// src/components/dashboard/ApplicationTracker.jsx
import { useState } from 'react';
import { C, STATUS_COLORS } from '../../styles/tokens';

const APPLICATIONS = [
  { role: 'Senior Product Designer', company: 'TechFlow Global', status: 'Interview',  logo: '🎨', match: 96, date: 'Jan 12', location: 'Remote · USA'  },
  { role: 'UX Research Lead',        company: 'Quantum Labs',    status: 'Reviewing',  logo: '🔬', match: 88, date: 'Jan 10', location: 'London, UK'     },
  { role: 'Head of Design',          company: 'NovaBridge',      status: 'Applied',    logo: '🌉', match: 79, date: 'Jan 8',  location: 'Remote · EU'    },
  { role: 'Product Strategist',      company: 'Apex Ventures',   status: 'Offer 🎉',  logo: '🚀', match: 91, date: 'Dec 28', location: 'Dubai, UAE'     },
];

const STAGE_LABELS = ['Applied', 'Reviewing', 'Interview', 'Offer 🎉'];

export default function ApplicationTracker() {
  const [selected, setSelected] = useState(null);

  return (
    <>
      <style>{`
        .pipeline-grid {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 8px;
          margin-bottom: 18px;
        }
        @media (max-width: 480px) {
          .pipeline-grid { grid-template-columns: repeat(2, 1fr) !important; }
        }
      `}</style>
      <div className="card" style={{ padding: '22px', display: 'flex', flexDirection: 'column', gap: 0 }}>
        <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:'16px' }}>
          <h3 className="syne" style={{ fontSize:'15px', fontWeight:700 }}>My Applications</h3>
          <div style={{ display:'flex', gap:'8px', alignItems:'center' }}>
            <span style={{ fontSize:'12px', color:'rgba(255,255,255,.4)' }}>12 total</span>
            <button style={{ padding:'6px 14px', background:'rgba(255,255,255,.05)', border:'1px solid rgba(255,255,255,.1)', borderRadius:'8px', color:'#fff', fontSize:'12px', fontWeight:600, cursor:'pointer' }}>View All</button>
          </div>
        </div>

        {/* Pipeline stages */}
        <div className="pipeline-grid">
          {STAGE_LABELS.map((stage) => {
            const count = APPLICATIONS.filter(a => a.status === stage).length;
            const color = STATUS_COLORS[stage] || C.lavender;
            return (
              <div key={stage} style={{ padding:'10px 12px', borderRadius:'10px', background:`${color}08`, border:`1px solid ${color}20`, textAlign:'center', cursor:'pointer', transition:'all .2s' }}
                onMouseEnter={e => { e.currentTarget.style.borderColor=`${color}50`; e.currentTarget.style.background=`${color}12`; }}
                onMouseLeave={e => { e.currentTarget.style.borderColor=`${color}20`; e.currentTarget.style.background=`${color}08`; }}>
                <div className="syne" style={{ fontSize:'18px', fontWeight:800, color }}>{count}</div>
                <div style={{ fontSize:'10px', color:'rgba(255,255,255,.45)', marginTop:'2px', fontWeight:600 }}>{stage.replace(' 🎉', '')}</div>
              </div>
            );
          })}
        </div>

        {/* Application rows */}
        <div style={{ display:'flex', flexDirection:'column', gap:'8px' }}>
          {APPLICATIONS.map((a, i) => {
            const color = STATUS_COLORS[a.status] || C.lavender;
            const isSelected = selected === i;
            return (
              <div key={i}
                onClick={() => setSelected(isSelected ? null : i)}
                style={{ padding:'12px 14px', borderRadius:'10px', background: isSelected ? 'rgba(254,52,232,.05)' : 'rgba(255,255,255,.025)', border: isSelected ? '1px solid rgba(254,52,232,.2)' : '1px solid rgba(255,255,255,.06)', cursor:'pointer', transition:'all .2s' }}
                onMouseEnter={e => { if (!isSelected) e.currentTarget.style.borderColor='rgba(254,52,232,.15)'; }}
                onMouseLeave={e => { if (!isSelected) e.currentTarget.style.borderColor='rgba(255,255,255,.06)'; }}
              >
                <div style={{ display:'flex', alignItems:'center', gap:'12px' }}>
                  <div style={{ width:'38px', height:'38px', borderRadius:'10px', background:'rgba(255,255,255,.05)', display:'flex', alignItems:'center', justifyContent:'center', fontSize:'18px', flexShrink:0 }}>{a.logo}</div>
                  <div style={{ flex:1, minWidth:0 }}>
                    <div style={{ fontSize:'13px', fontWeight:600, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{a.role}</div>
                    <div style={{ fontSize:'11px', color:'rgba(255,255,255,.4)', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{a.company} · {a.location}</div>
                  </div>
                  <span style={{ fontSize:'10px', padding:'3px 9px', borderRadius:'100px', background:`${color}15`, color, fontWeight:700, flexShrink:0, whiteSpace:'nowrap' }}>{a.status}</span>
                  <div style={{ width:'34px', height:'34px', borderRadius:'9px', background:`${color}10`, display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', flexShrink:0 }}>
                    <span className="syne" style={{ fontSize:'12px', fontWeight:800, color }}>{a.match}%</span>
                  </div>
                </div>
                {isSelected && (
                  <div style={{ marginTop:'12px', paddingTop:'12px', borderTop:'1px solid rgba(255,255,255,.06)', display:'flex', gap:'10px' }}>
                    <button style={{ flex:1, padding:'9px', background:`linear-gradient(135deg,${C.magenta},${C.violet})`, border:'none', borderRadius:'8px', color:'#fff', fontSize:'12px', fontWeight:700, cursor:'pointer', fontFamily:"'Syne',sans-serif" }}>View Details</button>
                    <button style={{ flex:1, padding:'9px', background:'rgba(255,255,255,.05)', border:'1px solid rgba(255,255,255,.1)', borderRadius:'8px', color:'#fff', fontSize:'12px', fontWeight:600, cursor:'pointer' }}>Withdraw</button>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
}
